import {
  RefundDto,
  RefundProgressDetailsDto,
  RefundModel,
  RefundProgressDetailsModel,
} from '../types/refund'

export const transformRefundProgressDetailsDto = (
  details: RefundProgressDetailsDto,
): RefundProgressDetailsModel => {
  const { status, title, exact_date, date, note } = details

  return {
    status,
    title,
    exactDate: exact_date,
    date,
    note,
  }
}

export const transformRefund = ({
  amount,
  currency,
  progress_details,
}: RefundDto): RefundModel => ({
  amount,
  currency,
  progressDetails: progress_details.map(transformRefundProgressDetailsDto),
})

export const transformRefundResponse = (response: { refund: RefundDto }): RefundModel =>
  transformRefund(response.refund)
